
import Vue from 'vue';
import { slugify } from '~/utility/helpers';

const getContactFetchKey = function (
  this: { uid: string; name: string; mail: string; phone: string; minimal: boolean; index?: number },
  getKey: (id: string) => number
) {
  const contactKey = `${this.uid || `${this.name}:${this.mail}:${this.phone}`}:${this.minimal}:${this.index ?? ''}`;
  return `ContactItemFetch:${contactKey}:${getKey(contactKey)}`;
};

export default Vue.extend({
  props: {
    uid: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'Max Mustermann',
    },
    serviceRole: {
      type: String,
      default: 'Ansprechpartner für Versand & Logistik',
    },
    businessArea: {
      type: String,
      default: 'Geschäftsfeld Baustoffe',
    },
    region: {
      type: String,
      default: 'Region Oberallgäu',
    },
    mail: {
      type: String,
      default: 'pius.geiger@geiger.de',
    },
    phone: {
      type: String,
      default: '01234 56 78 9',
    },
    link: {
      type: Object,
      default: () => {
        return {
          label: 'Kontaktaufnahme',
          url: '#',
        };
      },
    },
    minimal: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
  },

  data() {
    return {
      contact: {} as any,
    };
  },
  fetchKey: getContactFetchKey as any,
  async fetch() {
    // Get segments and roles from cache (should be preloaded by parent) or load if needed
    const [segments, roles] = await Promise.all([
      this.$getDataSourceCache('segment') || this.$loadDataSource('segment'),
      this.$getDataSourceCache('job-rollen') || this.$loadDataSource('job-rollen'),
    ]);

    if (this.uid) {
      const {
        data: { story: contactItem },
      } = await this.$store.app.$storyapi.get(`cdn/stories/${this.uid}`, {
        version: process.env.STORYBLOK_CONTENT_VERSION,
        resolve_links: 'url',
        find_by: 'uuid',
      });

      const contactLink = contactItem.content.link.length
        ? {
            label: contactItem.content.link[0].label,
            url: '/' + contactItem.content.link[0].link.cached_url,
          }
        : null;

      this.contact = {
        uuid: contactItem._uid,
        name: contactItem.content.name,
        businessArea: this.getBusinessArea(contactItem.content.segment, segments),
        serviceRole: this.getServiceRoles(contactItem.content.servicesRoles, roles),
        region: contactItem.content.region,
        mail: contactItem.content.mail,
        phone: contactItem.content.phone,
        link: contactLink,
        minimal: this.minimal,
        index: this.index,
      };
    } else {
      this.contact = {
        uuid: this.uid,
        name: this.name,
        serviceRole: this.serviceRole,
        businessArea: this.businessArea,
        region: this.region,
        mail: this.mail,
        phone: this.phone,
        link: {
          label: this.link.label,
          url: this.link.url,
        },
        minimal: this.minimal,
        index: this.index,
      };
    }
  },

  methods: {
    getServiceRoles(roles: any, rolesData: Record<string, any>) {
      return roles.map((item: any) => rolesData[slugify(item.role)]?.value || item.role).join(', ');
    },
    getBusinessArea(segment: any, segments: Record<string, any>) {
      return segments[slugify(segment)]?.value || segment;
    },
  },
});
